<template>
  <div class="w-full flex font-normal py-1 text-left">
    <div class="w-2/12 pt-2">
      <fa-icon
        v-if="!isSelected"
        :icon="['fal', 'circle']"
        size="lg"
        class="text-blue-400 cursor-pointer mx-4"
        @click="updateSelection()"
      />
      <fa-icon
        v-else
        :icon="['fas', 'circle']"
        size="lg"
        class="mx-4 text-blue-400 cursor-pointer"
        @click="updateSelection()"
      />
      {{ rule.phrase }}
    </div>
    <div class="w-2/12 flex">
      <div class="text-center w-full text-sm -mt-1">
        <fa-icon
          :icon="['fal', 'angle-up']"
          size="lg"
          class="text-gray-500 cursor-pointer hover:text-gray-700 block mx-auto"
          @click="increaseScore()"
        />
        <span class="pl-px">{{ score }}</span>
        <fa-icon
          :icon="['fal', 'angle-down']"
          size="lg"
          class="text-gray-500 cursor-pointer hover:text-gray-700 block mx-auto"
          @click="decreaseScore()"
        />
      </div>
    </div>
    <div class="w-2/12 py-2 pl-2">
      {{ language }}
    </div>
    <div class="w-1/12 p-2 text-center">
      <input
        v-model="stemmed"
        type="checkbox"
        @change="updateRule"
        disabled
      >
    </div>
    <div class="w-4/12 px-1">
      <div
        v-if="!projectDropdownOpened"
        class="px-2 flex"
        @click="projectDropdownOpened = true"
      >
        <div class="w-4/5">
          <span
            v-for="(project, index) in selectedProjects.slice(0, 2)"
            :key="index"
          >
            {{ project.name }}<span>{{ selectedProjects.length > 2 && index + 1 > 1 ? '...' : selectedProjects.length > index + 1 ? ',' : '' }}</span>
          </span>
        </div>
        <fa-icon
          class="float-right mt-1 mr-2 text-xl text-black"
          :icon="['fal', 'angle-down']"
        />
      </div>
      <project-dropdown
        v-if="projectDropdownOpened"
        :all-projects="allProjects"
        :selected-projects="selectedProjects"
        :has-label="false"
        :default-open="true"
        @select="addProject"
        @deselect="removeProject"
        @closeDropdown="projectDropdownOpened = false"
      />
    </div>
    <div class="w-1/12 px-3 py-2 flex">
      <vue-blob-json-csv
        file-type="json"
        :file-name="rule.phrase"
        :data="[downloadableData]"
      >
        <fa-icon
          :icon="['fal', 'arrow-to-bottom']"
          size="lg"
          class="mr-4 text-gray-400 cursor-pointer"
        />
      </vue-blob-json-csv>
      <fa-icon
        :icon="['fal', 'trash']"
        size="lg"
        class="text-gray-400 cursor-pointer"
        @click="deleteRule()"
      />
    </div>
  </div>
</template>

<script>
import { actionNames } from '@/sentiment-rules/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrash, faArrowToBottom, faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons'
import { faCircle as CircleSolid } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapState } from 'vuex'
import ProjectDropdown from '@/global/ui/ProjectDropdown/ProjectDropdown'

library.add(faTrash, faArrowToBottom, CircleSolid, faAngleDown, faAngleUp)
export default {
  name: 'Rule',
  components: {
    ProjectDropdown,
    'fa-icon': FontAwesomeIcon
  },
  props: {
    rule: { type: Object, default: () => {} },
    allProjects: { type: Array, default: () => ([]) },
    isSelected: { type: Boolean, default: false }
  },
  data () {
    return {
      score: '',
      stemmed: false,
      language: '',
      selectedProjects: [],
      projectDropdownOpened: false
    }
  },
  computed: {
    ...mapState({
      languages: state => state.sentimentRules.languages
    }),
    downloadableData () {
      return {
        phrase: this.rule.phrase,
        value: this.score,
        stemmed: this.rule.stemmed,
        lang: this.rule.lang
      }
    }
  },
  mounted () {
    this.score = this.rule.value
    this.stemmed = this.rule.stemmed
    this.language = this.languages.find(l => l.nickname === this.rule.lang).name
    this.selectedProjects = this.rule.projects
  },
  methods: {
    increaseScore () {
      if (this.score < 3) {
        this.score++
        this.updateRule()
      }
    },
    decreaseScore () {
      if (this.score > -3) {
        this.score--
        this.updateRule()
      }
    },
    async updateRule () {
      try {
        await this.$nextTick()
        await this.$store.dispatch(actionNames.UPDATE_RULE, {
          id: this.rule.id,
          score: this.score,
          projects: this.selectedProjects.map(sp => sp.id)
        })
        this.$toast.success(this.$t('Rule successfully updated', 'Rule successfully updated'))
      } catch (e) {
        this.$toast.error(this.$t('Something went wrong', 'Something went wrong'))
      }
    },
    deleteRule () {
      this.$emit('delete', this.rule.id)
    },
    updateSelection () {
      this.$emit('select-clicked', !this.isSelected)
    },
    addProject (p) {
      this.selectedProjects = [...this.selectedProjects, p]
      this.updateRule()
    },
    removeProject (p) {
      this.selectedProjects = this.selectedProjects.filter(sp => sp.id !== p.id)
      this.updateRule()
    }
  }
}
</script>
